<template>
    <div class="container-max">
        <table class="single__table" ref="table">
            <tbody :style="tableStyle">
                <tr
                    v-if="$store.getters.currentItemVariation.filter.hasManufacturer && $store.getters.currentItemVariation.item.manufacturer.externalName !== ''">
                    <td>{{ $translate("Ceres::Template.singleItemManufacturer") }}</td>
                    <td>{{ $store.getters.currentItemVariation.item.manufacturer.externalName }}</td>
                </tr>
                <tr v-if="hasDimensions && !hasDimensionsProp">
                    <td>{{ $translate("Ceres::Template.singleItemDimensions") }}</td>
                    <td>
                        <span>{{ $store.getters.currentItemVariation.variation.lengthMM }}</span>&nbsp; &times;
                        <span>{{ $store.getters.currentItemVariation.variation.widthMM }}</span>&nbsp; &times;
                        <span>{{ $store.getters.currentItemVariation.variation.heightMM }}</span> mm
                    </td>
                </tr>
                <tr
                    v-if="($store.getters.currentItemVariation.variation.weightG !== '' && $store.getters.currentItemVariation.variation.weightG != 0) || ($store.getters.currentItemVariation.variation.weightNetG !== '' && $store.getters.currentItemVariation.variation.weightNetG != 0)">
                    <td>{{ $translate("Ceres::Template.singleItemWeight") }}</td>
                    <td
                        v-if="$store.getters.currentItemVariation.variation.weightNetG !== '' && $store.getters.currentItemVariation.variation.weightNetG != 0">
                        {{ ($store.getters.currentItemVariation.variation.weightNetG / 1000).toString().replace('.',
                            ',') }} kg</td>
                    <td v-else>{{ ($store.getters.currentItemVariation.variation.weightG / 1000).toString().replace('.',
                        ',') }} kg</td>
                </tr>
                <tr v-for="prop in sortedProperties">
                    <td>{{ prop.property.names.name }}</td>
                    <td v-html="prop.texts.value"></td>
                </tr>
                <tr v-if="hasManufacturerDataPart1 || hasManufacturerDataPart2">
                    <td>{{ $translate("Weberbuero::Template.singleProductSafetyLabel") }}</td>
                    <td>
                        <a data-target="#eusafety" data-toggle="modal" href="#">
                            {{ $translate("Weberbuero::Template.singleProductSafetyLink") }}
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>

        <div id="eusafety-wrapper">
            <div class="modal fade" id="eusafety" tabindex="-1" role="dialog">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="modal-title h3">{{
                                $translate("Weberbuero::Template.singleProductSafetyModalTitle")
                                }}</div>
                            <button aria-label="Close" class="close" data-dismiss="modal" type="button"><span
                                    aria-hidden="true">×</span></button>
                        </div>
                        <div class="modal-body">
                            <div v-if="hasManufacturerDataPart1">
                                <strong class="h3">{{
                                    $translate("Weberbuero::Template.singleProductSafetyManufacturererInfo")
                                    }}</strong>
                                <div>
                                    <div v-if="manufacturerData.responsibleName">{{ manufacturerData.responsibleName
                                        }}</div>
                                    <div
                                        v-if="manufacturerData.responsibleStreet || manufacturerData.responsibleHouseNo">
                                        {{ manufacturerData.responsibleStreet
                                        }} {{
                                            manufacturerData.responsibleHouseNo }}</div>
                                    <div v-if="manufacturerData.responsiblePostCode">{{
                                        manufacturerData.responsiblePostCode
                                        }}</div>
                                    <div v-if="manufacturerData.responsibleTown">{{ manufacturerData.responsibleTown }}
                                    </div>
                                    <div v-if="manufacturerData.responsibleCountryObject">{{
                                        manufacturerData.responsibleCountryObject.names[0].name }}</div>
                                </div>
                            </div>
                            <div v-if="hasManufacturerDataPart2">
                                <strong class="h3">{{ $translate("Weberbuero::Template.singleProductSafetyContactInfo")
                                    }}</strong>
                                <div>
                                    <div v-if="manufacturerData.responsibleEmail">{{ manufacturerData.responsibleEmail
                                        }}</div>
                                    <div v-if="manufacturerData.responsiblePhoneNo">{{
                                        manufacturerData.responsiblePhoneNo }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { isNullOrUndefined } from "ceres/app/helper/utils";

export default {
    computed: {

        hasDimensionsProp() {
            for (let prop of this.sortedProperties) {
                if (prop.propertyId === 42 && prop.texts.value !== '') {
                    return true
                }
            }

            return false
        },

        manufacturerData() {
            return this.$store.getters.currentItemVariation.item.manufacturer;
        },

        hasManufacturerDataPart1() {
            if (this.manufacturerData.responsibleName || this.manufacturerData.responsibleStreet || this.manufacturerData.responsibleHouseNo || this.manufacturerData.responsiblePostCode || this.manufacturerData.responsibleTown || this.manufacturerData.responsibleCountryObject) {
                return true;
            }
        },

        hasManufacturerDataPart2() {
            if (this.manufacturerData.responsibleEmail !== '' || this.manufacturerData.responsiblePhoneNo) {
                return true;
            }
        },

        sortedProperties() {
            return this.$store.getters.currentItemVariation.properties
                .filter(prop => !isNullOrUndefined(prop.texts))
                .sort((a, b) => {
                    return a.property.position - b.property.position
                }
                )
        },
        tableStyle() {
            if (!this.tableHeight) {
                return {};
            }
            return {
                height: Math.ceil(this.tableHeight / 2) + 100 + "px"
            };
        },
        hasDimensions() {
            const variationData = this.$store.getters.currentItemVariation.variation;
            if (this.isZeroOrNull(variationData.lengthMM) && this.isZeroOrNull(variationData.widthMM) && this.isZeroOrNull(variationData.heightMM)) {
                return false;
            }
            return true;

        },
    },

    data() {
        return {
            tableHeight: null
        }
    },

    mounted() {
        this.$nextTick(() => {
            if (this.$refs.table) {
                this.calcTableHeight();
            }
        });
    },

    methods: {
        isZeroOrNull(value) {
            return value == 0 || !value;
        },
        calcTableHeight() {
            if (window.innerWidth >= 992) {

                this.tableHeight = null;
                this.$nextTick(() => {
                    let table = this.$refs.table;
                    const elHeight = table.offsetHeight;
                    // do some calculations based on height
                    this.tableHeight = elHeight;
                });

            }
        },
    }
}
</script>
